import axios from 'axios';
import { DonorURL } from '../../../../config/UrlEndPoint';

export const URL = `${DonorURL}`;

export function getFundType() {
    return axios.get(`${URL}fund_type`);
}
